import React, { useState } from 'react';

import shape5 from '../../../assets/images/shape-5.png';
import icon53 from '../../../assets/images/icon-53.png';
import icon54 from '../../../assets/images/icon-54.png';
import icon55 from '../../../assets/images/icon-55.png';
import contactImg from '../../../assets/images/Guidance.jpg';
// import LocationCenters from './LocationCenters'
import ServiceAreaMap from './ServiceAreaMap';
import { toast } from 'react-toastify';
import { axiosInstance, config } from '../config';
import Loader from '../../common/Loader';

const ContactIndex = () => {
  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [Loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!fullname) newErrors.fullname = 'Full name is required.';
    if (!email) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Email address is invalid.';
    }

    const phoneRegex = /^\d{10,15}$/;
    if (!phone) {
      newErrors.phone = 'Phone number is required';
    } else if (!phoneRegex.test(phone)) {
      newErrors.phone = 'Phone number must be between 10 and 15 digits.';
    }

    if (!subject) newErrors.subject = 'Subject is required.';
    if (!message) newErrors.message = 'Message is required.';

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
      setErrors({});
      // Handle form submission logic here

      try {
        setLoading(true);
        const formData = new FormData();

        formData.append('name', fullname);
        formData.append('phone', phone);
        formData.append('email', email);
        formData.append('subject', subject);
        formData.append('message', message);

        const res = await axiosInstance.post('add-enquiry', formData, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
          },
        });

        if (res.data.success == true) {
          toast.success('Your Message has been sent successfully.');
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
        toast.error('Something went wrong !');
        setLoading(false);
      }
      setFullname('');
      setEmail('');
      setPhone('');
      setSubject('');
      setMessage('');
    } else {
    }
  };

  return (
    <>
      {Loading && <Loader />}
      <section className="contact-section ">
        <div className="shape" style={{ backgroundImage: `url(${shape5})` }} />
        <div className="auto-container">
          <div className="inner-container">
            <div className="row clearfix">
              <div className="col-lg-5 col-md-12 col-sm-12 inner-column">
                <div
                  className="inner-box h-100"
                  style={{
                    backgroundImage: `url(${contactImg})`,
                  }}
                >
                  <div className="inner">
                    <div className="single-item">
                      <div className="icon-box">
                        <img src={icon54} alt="Contact Us Icon" />
                      </div>
                      <h4>Quick Contact</h4>
                      <p>
                        <i
                          className="bi bi-telephone"
                          style={{ marginRight: '6px' }}
                        ></i>
                        <a href="tel:0116 210 2688">0116 210 2688</a> <br />
                        <i
                          className="bi bi-telephone"
                          style={{ marginRight: '6px' }}
                        ></i>
                        <a href="tel:+44 7380 851496">+44 7380 851496</a>
                        <br />
                        <i
                          className="bi bi-envelope"
                          style={{ marginRight: '6px' }}
                        ></i>
                        <a href="mailto:info@precisiondriving.uk">
                          info@precisiondriving.uk
                        </a>
                      </p>
                    </div>
                    <div className="single-item">
                      <div className="icon-box">
                        <img src={icon53} alt="Contact Us Icon" />
                      </div>
                      <h4>We are Here</h4>
                      <p>4 Rivers Street, Leicester, England, LE3 5RX</p>
                    </div>
                    <div className="single-item">
                      <div className="icon-box">
                        <img src={icon55} alt="Contact Us Icon" />
                      </div>
                      <h4>Opening Hours</h4>
                      <p>
                        <span className="text-white">Mon-Fri:</span> 8:00 AM –
                        6:00 PM <br />
                        <span className="text-white">Saturday:</span> 10:00 AM –
                        2:00 PM <br />
                        <span className="text-white">Sunday:</span> Closed
                      </p>
                    </div>
                  </div>
                  <h5 className="text-white mb-2">Follow Us</h5>
                  <ul className="social-links clearfix">
                    <li>
                      <a
                        href="https://www.facebook.com/PrecisionDrivingSchoolLimited"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="bi bi-facebook" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/precisiondriving_leicester/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="bi bi-instagram" />
                      </a>
                    </li>
                    {/* <li>
                                            <a href="#">
                                                <i className="bi bi-twitter-x" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="bi bi-linkedin" />
                                            </a>
                                        </li> */}
                  </ul>
                </div>
              </div>
              <div className="col-lg-7 col-md-12 col-sm-12 form-column">
                <div className="form-inner">
                  <div className="sec-title light">
                    <h2>Send your enquiry</h2>
                    <p>
                      Complete the enquiry form &amp; we will be in touch as
                      soon as possible.
                    </p>
                  </div>
                  <form id="contact-form" onSubmit={handleSubmit}>
                    <div className="row clearfix">
                      <div className="col-sm-12 form-group">
                        <input
                          type="text"
                          name="username"
                          placeholder="Full Name"
                          required=""
                          aria-required="true"
                          value={fullname}
                          onChange={(e) => setFullname(e.target.value)}
                        />
                        {errors.fullname && (
                          <p className="badge text-red">{errors.fullname}</p>
                        )}
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email Address"
                          required=""
                          aria-required="true"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        {errors.email && (
                          <p className="badge text-red">{errors.email}</p>
                        )}
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                        <input
                          type="text"
                          name="phone"
                          required=""
                          placeholder="Phone"
                          aria-required="true"
                          value={phone}
                          maxLength={15}
                          inputMode="numeric"
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            setPhone(value);
                          }}
                        />
                        {errors.phone && (
                          <p className="badge text-red">{errors.phone}</p>
                        )}
                      </div>
                      <div className="col-sm-12 form-group">
                        <input
                          type="text"
                          name="username"
                          placeholder="Subject"
                          required=""
                          aria-required="true"
                          value={subject}
                          onChange={(e) => setSubject(e.target.value)}
                        />
                        {errors.subject && (
                          <p className="badge text-red">{errors.subject}</p>
                        )}
                      </div>
                      {/* <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                                <div className="select-box">
                                                    <select className="wide form-select rounded-0 py-3 text-secondary" >
                                                        <option data-display="I am parent looking course for my teen">
                                                            I am parent looking course for my teen
                                                        </option>
                                                        <option value={1}>Driving Course</option>
                                                        <option value={2}>Driving License</option>
                                                        <option value={3}>Insurance</option>
                                                        <option value={4}>Road Safety Guide</option>
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                                <div className="select-box">
                                                    <select className="wide form-select rounded-0 py-3 text-secondary" >
                                                        <option data-display="Extended Driving Course">
                                                            Extended Driving Course
                                                        </option>
                                                        <option value={1}>Driving Course</option>
                                                        <option value={2}>Driving License</option>
                                                        <option value={3}>Insurance</option>
                                                        <option value={4}>Road Safety Guide</option>
                                                    </select>

                                                </div>
                                            </div> */}
                      <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                        <textarea
                          name="message"
                          placeholder="Message"
                          defaultValue={''}
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        />
                        {errors.message && (
                          <p className="badge text-red">{errors.message}</p>
                        )}
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn">
                        <button
                          type="submit"
                          className="theme-btn"
                          name="submit-form"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              className="lower-box centred"
              style={{ backgroundColor: '#ca2319' }}
            >
              <h5>
                <a
                  href="https://www.google.com/maps/place/4+Rivers+St,+Leicester+LE3+5RX,+UK/@52.6356379,-1.150109,17z/data=!3m1!4b1!4m6!3m5!1s0x487760e7cb15914d:0xf327f0cb79553698!8m2!3d52.6356347!4d-1.1475341!16s%2Fg%2F11kpzrdgdw?entry=ttu&g_ep=EgoyMDI0MDkyOS4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  className="text-white"
                  rel="noreferrer"
                >
                  <i
                    className="bi bi-geo-alt-fill"
                    style={{ marginRight: '8px' }}
                  ></i>
                  Our Office Location — View on Google Maps
                </a>
              </h5>
            </div>
          </div>
        </div>
      </section>

      {/* <LocationCenters /> */}
      <ServiceAreaMap />
    </>
  );
};

export default ContactIndex;
